// assets/discount-visual.js
(function () {
  const $  = (s) => document.querySelector(s);
  const qp = (n) => { try { return new URLSearchParams(location.search).get(n); } catch { return null; } };
  const fmt = (amt, cur) => {
    try { return new Intl.NumberFormat('da-DK', { style:'currency', currency: cur||'DKK' }).format(amt); }
    catch { return (cur||'') + ' ' + (amt||0).toFixed(2); }
  };

  function getPD() {
    const hooks = $('#discount-hooks');
    if (!hooks) return null;
    const sid = hooks.getAttribute('data-discount-section-id');
    const el = document.getElementById('product-json-' + sid);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch { return null; }
  }

  function getSelectedVariant(pd) {
    const id = document.querySelector('form[action*="/cart/add"] [name="id"]');
    const vid = id && id.value ? String(id.value) : null;
    if (!vid || !pd || !Array.isArray(pd.variants)) return null;
    return pd.variants.find(v => String(v.id) === vid) || null;
  }

  function compute(cents, pct, amt) {
    const original = (cents||0)/100;
    let discounted = original;
    if (pct && pct > 0) discounted = original * (1 - pct/100);
    else if (amt && amt > 0) discounted = Math.max(0, original - amt);
    return { original, discounted };
  }

  function showBanner(code) {
    const b = $('#discount-code-banner'); if (!b) return;
    const el = b.querySelector('.discount-code-badge__code'); if (el) el.textContent = code;
    b.style.display = 'inline-flex';
  }

  function showComputedPrice(original, discounted, currency) {
    const box = $('#computed-discount-price'), sale = $('#cdp-sale'), reg = $('#cdp-regular');
    if (!box || !sale || !reg) return;
    sale.textContent = fmt(discounted, currency);
    reg.textContent  = fmt(original,  currency);
    box.style.display = 'block';
  }

  function init() {
    // 1) discount SKAL være i URL’en
    const code = qp('discount');
    if (!code) return;

    // 2) lock_to SKAL matche aktuelt produkt-handle
    const hooks = $('#discount-hooks');
    if (!hooks) return;
    const currentHandle = hooks.getAttribute('data-product-handle') || '';
    const lockTo = qp('lock_to') || '';
    if (!lockTo || lockTo !== currentHandle) return; // hård lås

    // 3) vis banner
    showBanner(code);

    // 4) vis beregnet pris KUN hvis d_pct eller d_amount er sat
    const pct = qp('d_pct') ? Math.max(0, parseFloat(qp('d_pct'))) : null;
    const amt = qp('d_amount') ? Math.max(0, parseFloat(qp('d_amount'))) : null;
    if (!(pct || amt)) return;

    const currency = hooks.getAttribute('data-discount-currency') || 'DKK';
    const pd = getPD();
    if (!pd) return;

    const render = () => {
      const v = getSelectedVariant(pd);
      if (!v) return;
      const { original, discounted } = compute(v.price, pct, amt);
      showComputedPrice(original, discounted, currency);
    };

    render();
    document.addEventListener('variant:change', (e) => {
      const v = e && e.detail && e.detail.variant;
      if (v) {
        const r = compute(v.price, pct, amt);
        showComputedPrice(r.original, r.discounted, currency);
      } else {
        render();
      }
    });
    const idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (idInput) idInput.addEventListener('change', render);
    setTimeout(render, 300);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
